
const RBox = ({ lines, x, y, width, height, className, paddingTop, ...props }) => {
	const centerx = parseFloat(x) + (width / 2)

	if (paddingTop === undefined) {
		paddingTop = false
	}

	return (
		<>
			<rect {...props} className={className + " box"} rx="10" x={x} y={y} width={width} height={height} />
			<text
				style={{ transform : `rotate(270deg)`, transformOrigin : 'left top', transformBox : 'fill-box' }}
				className="box r"
				x={centerx + 55}
				y={y + height}
				textAnchor="middle">
				{lines}
			</text>
		</>
	)
}

export default RBox
